function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.8 0H1.2C0.5364 0 0 0.5364 0 1.2V10.8C0 11.4636 0.5364 12 1.2 12C1.8636 12 2.4 11.4636 2.4 10.8V2.4H21.6V21.6H13.2C12.5364 21.6 12 22.1364 12 22.8C12 23.4636 12.5364 24 13.2 24H22.8C23.4636 24 24 23.4636 24 22.8V1.2C24 0.5364 23.4636 0 22.8 0ZM2.4 21.6H7.2V16.8H2.4V21.6ZM8.4 14.4H1.2C0.5364 14.4 0 14.9364 0 15.6V22.8C0 23.4636 0.5364 24 1.2 24H8.4C9.0636 24 9.6 23.4636 9.6 22.8V15.6C9.6 14.9364 9.0636 14.4 8.4 14.4ZM12.8484 12.8484L16.8 8.8968V12C16.8 12.6636 17.3364 13.2 18 13.2C18.6636 13.2 19.2 12.6636 19.2 12V6C19.2 5.3364 18.6636 4.8 18 4.8H12C11.3364 4.8 10.8 5.3364 10.8 6C10.8 6.6636 11.3364 7.2 12 7.2H15.1032L11.1516 11.1516C10.6824 11.6208 10.6824 12.3792 11.1516 12.8484C11.3856 13.0824 11.6928 13.2 12 13.2C12.3072 13.2 12.6144 13.0824 12.8484 12.8484Z",
  fill: "#637381"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.8 0H1.2C0.5364 0 0 0.5364 0 1.2V10.8C0 11.4636 0.5364 12 1.2 12C1.8636 12 2.4 11.4636 2.4 10.8V2.4H21.6V21.6H13.2C12.5364 21.6 12 22.1364 12 22.8C12 23.4636 12.5364 24 13.2 24H22.8C23.4636 24 24 23.4636 24 22.8V1.2C24 0.5364 23.4636 0 22.8 0ZM2.4 21.6H7.2V16.8H2.4V21.6ZM8.4 14.4H1.2C0.5364 14.4 0 14.9364 0 15.6V22.8C0 23.4636 0.5364 24 1.2 24H8.4C9.0636 24 9.6 23.4636 9.6 22.8V15.6C9.6 14.9364 9.0636 14.4 8.4 14.4ZM12.8484 12.8484L16.8 8.8968V12C16.8 12.6636 17.3364 13.2 18 13.2C18.6636 13.2 19.2 12.6636 19.2 12V6C19.2 5.3364 18.6636 4.8 18 4.8H12C11.3364 4.8 10.8 5.3364 10.8 6C10.8 6.6636 11.3364 7.2 12 7.2H15.1032L11.1516 11.1516C10.6824 11.6208 10.6824 12.3792 11.1516 12.8484C11.3856 13.0824 11.6928 13.2 12 13.2C12.3072 13.2 12.6144 13.0824 12.8484 12.8484Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var SvgFullScreen = function SvgFullScreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFullScreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fullScreen.8d0e44b5.svg";
export { ForwardRef as ReactComponent };